<template>
  <div class="animated fadeIn scroll" :style="divstyle">
    <div v-if="loading">
      <semipolar-spinner :animation-duration="2000" :size="65" color="#ff1d5e" />Loading...
    </div>
    <div v-if="!loading">
      <b-modal
        title="Messaggio inviato"
        class="modal-success"
        v-model="okShow"
        @ok="okShow=false,reset()"
        ok-variant="success"
        :ok-only="true"
      >
        Messaggio inviato
      </b-modal>
      <h1>
        Invio messaggi
        <span v-if="noprogsel">{{progsel ? progsel.nome : ''}}</span>
      </h1>
      <span v-if="!noprogsel">
        Progetto:
        <multiselect
          id="progettilist"
          v-model="progsel"
          :options="progetti"
          :multiple="false"
          :close-on-select="true"
          label="nome"
          track-by="progettoid"
          :disabled="noprogsel"
          @input="fprogsel"
        ></multiselect>
      </span>
      <br />
      <hr />
      <span>
        Alunno:
        <multiselect
          id="alunnilist"
          v-model="alsel"
          :options="alunni"
          :multiple="false"
          :close-on-select="true"
          label="nome"
          track-by="alunnoid"
          @input="falsel"
        ></multiselect>
      </span>
      <br />
      <hr />
      <div id="sn_editor"></div>
      <br />Link:
      <br />
      <input type="text" class="link" v-model.lazy="link" />
      <br />
      <br />
      <button @click="savetext()">INVIA</button>
    </div>
  </div>
</template>
<script>
import { API } from "@/api.js";
import { SemipolarSpinner } from "epic-spinners";
import { DateTime } from "luxon";
import Peity from "vue-peity";
import { ToggleButton } from "vue-js-toggle-button";

export default {
  name: "messaggi",
  mixins: [window.myMixin],
  components: {
    SemipolarSpinner,
    Peity,
    ToggleButton
  },
  data: function() {
    return {
      noprogsel: false,
      loading: false,
      progsel: {},
      alsel: {},
      progetti: [],
      alunni: [],
      link: "",
      okShow: false,
      testo: "",
    };
  },
  props: ["noframe"],
  watch: {},
  filters: {
    itadata: function(value) {
      if (!value || value == "") return "";
      return value
        .split("-")
        .reverse()
        .join("/");
    }
  },
  computed: {
    divstyle: function() {
      return `height: calc(100vh - ${this.noframe ? 0 : 180}px);`;
    }
  },
  beforeDestroy() {
    // console.log("beforeDestroy");
    $("#sn_editor").summernote("destroy");
  },
  beforeUpdate() {
    // console.log("beforeUpdate");
    this.testo = $("#sn_editor").summernote("code");
    $("#sn_editor").summernote("destroy");
  },
  updated() {
    // console.log("updated");
    this.setEditor(this.testo);
  },
  methods: {
    reset: function(){
      this.alsel = null
      this.link = ""
      $("#sn_editor").summernote("code", "");
    },
    async savetext() {
      var markup = $("#sn_editor").summernote("code");
      //$("#sn_editor").summernote("destroy");
      // console.log("MARKUP", markup);
      let corsisti = this.alsel.corsistaid;
      // console.log("CORSISTI", corsisti);
      let link = this.link;
      // console.log("LINK", link);
      corsisti.forEach(c => {
        var ret = API.sqlprep(this, "messaggi.send", [
          c,
          markup,
          link,
          this.getUserID()
        ]);
      });
      this.okShow = true
    },
    falsel: async function() {
      var me = this;
      // console.log("ALSEL:", this.alsel);
    },
    fprogsel: async function() {
      var me = this;
      this.loading = true;
      // console.log("PROGSEL:", this.progsel);
      if(!this.progsel) return
      // elenco alunni
      var als = await API.sqlprep(this, "registro.selals", [
        null,this.progsel.progettoid
      ]);
      var als2 = await API.sqlprep(this, "registro.selalsappr", [
        this.progsel.progettoid,
        this.progsel.progettoid,
        null
      ]);
      var alunni = als.data.dati
        .map(m => ({
          alunnoid: m.alunnoid,
          nome: m.cognome + " " + m.nome,
          corsistaid: [m.corsistaid],
          posizione: m.posizione || 0
        }))
        .sort((a, b) => {
          return a.posizione - b.posizione;
        });
      var alunni2 = als2.data.dati
        .map(m => ({
          alunnoid: m.alunnoid,
          nome: m.cognome + " " + m.nome,
          corsistaid: [m.corsistaid],
          posizione: "APPR"
        }))
        .sort((a, b) => {
          if (a.cognome < b.cognome) return -1;
          else if (a.cognome > b.cognome) return 1;
          else return 0;
        });
      alunni = alunni.concat(alunni2);
      alunni.unshift({
        alunnoid: 0,
        nome: "TUTTI",
        corsistaid: als.data.dati.map(a => a.corsistaid),
        posizione: false
      });
      // console.log("??",als.data.dati.map(a => a.corsistaid))
      this.alunni = alunni;
      this.loading = false;
    },
    setEditor(text) {
      this.$nextTick(() => {
        $("#sn_editor").summernote({
          height: 200,
          toolbar: [
            ["style", ["style"]],
            [
              "font-style",
              [
                "bold",
                "italic",
                "underline",
                "strikethrough",
                "superscript",
                "subscript",
                "clear"
              ]
            ],
            ["font", ["fontname"]],
            ["font-size", ["fontsize"]],
            ["font-color", ["color"]],
            ["para", ["ul", "ol", "paragraph"]],
            ["table", ["table"]],
            ["insert", ["link", "picture", "video", "hr"]],
            ["misc", ["fullscreen", "codeview", "help"]]
          ]
        });
        $("#sn_editor").summernote("code", text);
      });
    }
  },
  mounted: async function() {
    this.loading = true;
    var url = new URL(window.location.href);
    var progettoid = url.searchParams.get("progettoid");
    // console.log("PAR progettoid:",progettoid)

    var token = this.getTokenData().sub;
    var prgs;
    var sql;
    if (this.getUserLIV() >= 5)
      prgs = await API.sqlprep(this, "registro.selprog", []);
    else
      prgs = await API.sqlprep(this, "registro.selprogsede", [
        token.user.sedeid
      ]);

    this.progetti = prgs.data.dati
      .map(p => ({
        progettoid: p.progettoid,
        annualita: p.annualita,
        nome: p.numero + " - " + p.nome
      }))
      .sort((a, b) => {
        if (a.nome < b.nome) return -1;
        else if (a.nome > b.nome) return 1;
        else return 0;
      });

    if (progettoid) {
      this.progsel = this.progetti.find(p => p.progettoid == progettoid);
      this.noprogsel = true;
      // console.log("MOUNT...",progettoid,this.progsel,this.noprogsel)
      await this.fprogsel()
      // console.log("AFTER await")
    }
    this.loading = false;
    this.setEditor();
  }
};
</script>
<style scoped>
input.link {
  width: 100%;
}
.blink {
  animation: blink 0.5s linear infinite;
}
</style>
<style>
</style>
